// The WhatsApp connection: the tenant's accounts and numbers, and Embedded
// Signup (ADR-0014). The browser only ever sends Meta's code and ids; the
// token is exchanged and kept on the server.
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api, unwrap } from './client'
import type { components } from './generated/schema'

export type WhatsAppConnection = components['schemas']['WhatsAppConnection']
export type WhatsAppAccount = components['schemas']['WhatsAppAccount']
export type WhatsAppNumber = components['schemas']['WhatsAppNumber']
export type WhatsAppSignup = components['schemas']['WhatsAppSignup']
export type WhatsAppConnectResult = components['schemas']['WhatsAppConnectResult']

const key = ['whatsapp'] as const

export function useWhatsAppConnection() {
  return useQuery({
    queryKey: key,
    queryFn: async (): Promise<WhatsAppConnection> => unwrap(await api.GET('/whatsapp')),
  })
}

export function useConnectWhatsApp() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (body: WhatsAppSignup): Promise<WhatsAppConnectResult> => unwrap(await api.POST('/whatsapp/connect', { body })),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: key })
      // The meter and the campaign editor show numbers too.
      void qc.invalidateQueries({ queryKey: ['meter'] })
      void qc.invalidateQueries({ queryKey: ['numbers'] })
    },
  })
}
